<template lang="html">

  <section class="evenement">
    <div id="content">
        <div id="cinemaHeader" :class="['section', 'categoryheader', imageBanniere]">
            
            <div class="categorytitle">
                <h1>
                    <small>SKANTICKET</small><br/>
                    {{type}}
                </h1>
            </div>

        </div>

        <panel-evenement :titre="titreListeEvenement" :message="messageListeEvenement" :type="type"/>
        <pied-creer-billetterie/>
    </div>
  </section>

</template>

<script lang="js">
  import PanelEvenement from "@/components/PanelEvenement.vue"
  import PiedCreerBilletterie from "@/components/PiedCreerBilletterie"

  export default  {
    name: 'evenement',
    props: [
      'type'
    ],
    mounted() {

    },
    data() {
      return {
        typesBilletterie : [
          {
            titreBanniere: "EVENEMENTS", 
            imageBanniere: "imageBanniereEvenement",
            titreListeEvenement: "A la une des Evénements", 
            messageListeEvenement: "Découvrez les événements du moment"
          }/*,
          {
            titreBanniere: "CINEMA", 
            imageBanniere: "imageBanniereCinema",
            titreListeEvenement: "A la une au Cinéma", 
            messageListeEvenement: "Decouvrez les films du moment"
          }*/
        ]
      }
    },
    methods: {

    },
    computed: {
      titreListeEvenement: function() {
        for(let i in this.typesBilletterie){
          if(this.typesBilletterie[i]["titreBanniere"]==this.type){
            return this.typesBilletterie[i]["titreListeEvenement"];
          }
        }

        return null;
      },
      messageListeEvenement: function() {
        for(let i in this.typesBilletterie){
          if(this.typesBilletterie[i]["titreBanniere"]==this.type){
            return this.typesBilletterie[i]["messageListeEvenement"];
          }
        }

        return null;
      },
      imageBanniere: function() {
        for(let i in this.typesBilletterie){
          if(this.typesBilletterie[i]["titreBanniere"]==this.type){
            return this.typesBilletterie[i]["imageBanniere"];
          }
        }

        return null;
      }
    },
    components:{
      PanelEvenement,
      PiedCreerBilletterie
    }
}
</script>

<style scoped>

.searchNofound{
    margin: auto;
    width: 33em;
}

.searchNofound img{
    width: 4.5em;
    padding-top: 5.8em;
    color: var(--sk-lightgrey);
    
}
.searchNofound h4{
    color: var(--sk-lightgrey);
}
.searchNofound{
    text-align: center;
}
.segment{
    background-color: #E3E3E3;
    border-radius: 0.8em;
    padding: 2em .5em;
}
.slideCat{
    height: 8em;
    padding-top: 0;
    padding-bottom: 0;
    position: relative;
    
}
.imagCat{
    height: 8em;
    padding-top: 0;
    padding-bottom: 0;
    position: absolute;
    
}
.imagCat img{
    height: 100%;
    width: 100%;
    margin-left: 1.5em;
    border-radius: 0.8em;
    
}
.overlayCat{
    position: absolute;
    top:0;
    padding-top: 3em;
    margin-left: 1.5em;
    /* margin-right: 0; */
    height: 100%;
    width: 100%;
    color: white;
    background-color: rgba(14, 20, 27, 0.7);
    border-radius: 0.8em;
}
.overlayCat h6{
    margin-top: .7em;
}

.imageBanniereCinema{
  background-image: url(../assets/img/cinema_bg_2.jpg);
}

.imageBanniereEvenement{
  background-image: url(../assets/img/evenement_2.jpg);
}
</style>
